import {SupportInfo} from 'app_api/billing/types';

import {BaseClient} from '../utils/base-client';

class SupportInfoClient extends BaseClient<SupportInfo> {
  buildEndpoint() {
    return `api/app/billing/user_support_info`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const supportInfoClient = new SupportInfoClient();
